import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=21fbeb11&scoped=true"
import script from "./PopupContent.vue?vue&type=script&lang=js"
export * from "./PopupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fbeb11",
  null
  
)

export default component.exports